import React from 'react';

import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import { Route, Switch } from 'react-router-dom';
import BookTee from '../src/components/bookTee'
import AddPlayers from '../src/components/addPlayers'
import './App.css';
import payNow from './components/payNow';
import myAccount from './components/myAccount';
import Success from './components/success'
import UserSuccess from './components/userSuccess'
import hoc from './components/hoc/protectedRoute'
import Register from './components/ui/RegisterComponent'
import { useIdleTimer } from 'react-idle-timer'
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import Fab from '@material-ui/core/Fab';
import HomeIcon from '@material-ui/icons/Home';

const styles = theme => ({
  fixedbutton : {
      position: 'fixed',
      bottom: 200,
      right: 50
  }, 
  fabIconBtn: {
      width: '100px',
      height: '100px',
      background: '#F4A522',
      zIndex: '99999999'
  }
})


function App({classes}) {
  const location = useLocation()
  const { mode } = queryString.parse(location.search)
  const onIdle = () => {
      window.location.href = "https://tanglewoodresort.com/kiosk-main"
  }

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: 90_000,
    throttle: 500
  })
  return (


    <div className="App">
      <Fab onClick={() => window.location.href = "https://tanglewoodresort.com/kiosk-main"} className={classes.fixedbutton} size="large" classes={{ root: classes.fabIconBtn}}>
            <HomeIcon style={{fontSize: '60px'}}></HomeIcon>
        </Fab>
      <Switch>
        <Route exact path="/" component={hoc(BookTee)} />
        <Route exact path="/players/:eventId/book/:postingId" component={hoc(AddPlayers)} />
        <Route exact path="/pay" component={hoc(payNow)} />
        <Route exact path="/account" component={myAccount} />
        <Route exact path="/event/:eventId/guest/:guestId/charge/:chargeId/success" component={Success} />
        <Route exact path="/event/:eventId/trans/:transId/charge/:chargeId/success" component={UserSuccess} />
        <Route exact path="/register" component={Register} />
      </Switch>
    </div>
  );
}

export default withStyles(styles)(withRouter(App));
